import React from "react";
import EiaLink from "../../components/tables/EiaLink";

export const getLink = function (name, link) {
    return <EiaLink name={name} link={link} isExternal={true} />
}

export const genesis = function () {
    return getLink("Genesis", "https://www.wowhead.com/diablo-4/item/tuning-stone-genesis-1723635")
}

export const evernight = function () {
    return getLink("Evernight", "https://www.wowhead.com/diablo-4/item/tuning-stone-evernight-1723622")
}

export const uniquesLink = getLink("Uniques", "https://www.wowhead.com/diablo-4/guide/gear/target-farming#general-uniques");
export const runesLink = getLink("Runes", "https://www.wowhead.com/diablo-4/guide/gear/runes-runewords")
export const summoningMaterialsLink = getLink("Summoning Materials", "https://www.wowhead.com/diablo-4/items/boss-summoning");
export const difficultyLink = getLink("Difficulty", "https://www.wowhead.com/diablo-4/news/new-difficulty-system-unveiled-diablo-4-patch-2-0-ptr-346346")

export const mythicsLink = getLink("Mythics", "https://www.wowhead.com/diablo-4/news/all-mythic-unique-updates-for-diablo-4-season-5-345623");
export const bossUniqueDrops = getLink("Uniques", "https://www.wowhead.com/diablo-4/guide/gear/target-farming#boss-drop-table-by-item");
export const zirUniques = getLink("Uniques", "https://www.wowhead.com/diablo-4/guide/gear/target-farming#dark-master-lord-zir");
export const varshanUniques = getLink("Uniques", "https://www.wowhead.com/diablo-4/guide/gear/target-farming#echo-of-varshan");
export const grigoireUniques = getLink("Uniques", "https://www.wowhead.com/diablo-4/guide/gear/target-farming#grigoire-the-galvanic-saint");
export const beastInIceUniques = getLink("Uniques", "https://www.wowhead.com/diablo-4/guide/gear/target-farming#the-beast-in-the-ice");

// specific uniques
export const fistsOfFate = getLink("Fists of Fate", "https://www.wowhead.com/diablo-4/item/fists-of-fate-186283");
export const flickerStep = getLink("Flickerstep", "https://www.wowhead.com/diablo-4/item/flickerstep-291669");
export const rakanothsWake = getLink("Rakanoth's Wake", "https://www.wowhead.com/diablo-4/item/rakanoths-wake-1944504");
export const theOculus = getLink("The Oculus", "https://www.wowhead.com/diablo-4/item/the-oculus-1439530")
export const tibaultsWill = getLink("Tibault's Will", "https://www.wowhead.com/diablo-4/item/tibaults-will-1559419")
export const uglyBastardHelm = getLink("Ugly Bastard Helm", "https://www.wowhead.com/diablo-4/item/ugly-bastard-helm-1788901")
export const arreatsBearing = getLink("Arreat's Bearing", "https://www.wowhead.com/diablo-4/item/arreats-bearing-1901740")

export const newSeasonUniques = new Map([
    [12, [
        ["Blood-Mad Idol", "https://www.wowhead.com/diablo-4/item/blood-mad-idol-1719158"],
        ["Wendigo Brand", "https://www.wowhead.com/diablo-4/item/wendigo-brand-2538578"],
        ["Wyrdskin", "https://www.wowhead.com/diablo-4/item/wyrdskin-2538889"],
        ["Rustbitten Dirk", "https://www.wowhead.com/diablo-4/item/rustbitten-dirk-2424373"],
        ["Thousand-Eye Reaver", "https://www.wowhead.com/diablo-4/item/thousand-eye-reaver-2538899"],
    ]],
    [11, [
        ["Chainscourged Mail", "https://www.wowhead.com/diablo-4/item/16711885"],
        ["Khamsin Steppewalkers", "https://www.wowhead.com/diablo-4/item/16711886"],
        ["Gravebloom", "https://www.wowhead.com/diablo-4/item/16711888"],
        ["Death's Pavane", "https://www.wowhead.com/diablo-4/item/16711887"],
        ["Orsivane", "https://www.wowhead.com/diablo-4/item/16711884"],
        ["Path Of The Emissary", "https://www.wowhead.com/diablo-4/item/16711889"],
    ]],
    [10, [
        ["Sabre of Tsasgal", "https://www.wowhead.com/diablo-4/item/sabre-of-tsasgal-2363572"],
        ["Kilt of Blackwing", "https://www.wowhead.com/diablo-4/item/kilt-of-blackwing-2363617"],
        ["Gospel of the Devotee", "https://www.wowhead.com/diablo-4/item/gospel-of-the-devotee-2363567"],
        ["Orphan Maker", "https://www.wowhead.com/diablo-4/item/orphan-maker-1206099"],
        ["Galvanic Azurite", "https://www.wowhead.com/diablo-4/item/galvanic-azurite-2363629"],
        ["Hesha e Kesungi", "https://www.wowhead.com/diablo-4/item/hesha-e-kesungi-2363606"],
    ]],
    [9, [
        ["Hooves of the Mountain God", "https://www.wowhead.com/diablo-4/item/hooves-of-the-mountain-god-2059805"],
        ["Rotting Lightbringer", "https://www.wowhead.com/diablo-4/item/rotting-lightbringer-2242286"],
        ["The Hand of Naz", "https://www.wowhead.com/diablo-4/item/the-hand-of-naz-2242301"],
        ["Deathmask of Nirmitruq", "https://www.wowhead.com/diablo-4/item/deathmask-of-nirmitruq-455405"],
        ["Ophidian Iris", "https://www.wowhead.com/diablo-4/item/2242304"],
        ["Balazan's Maxtlatl", "https://www.wowhead.com/diablo-4/item/2242307"],
    ]],
    [8, [
        ["Bane of Ahjad-Den", "https://www.wowhead.com/diablo-4/item/bane-of-ahjad-den-2081122"],
        ["Gathlen's Birthright", "https://www.wowhead.com/diablo-4/item/gathlens-birthright-2081129"],
        ["Sanguivor, Blade of Zir", "https://www.wowhead.com/diablo-4/item/sanguivor-blade-of-zir-2081159"],
        ["Bands of Ichorous Rose", "https://www.wowhead.com/diablo-4/item/bands-of-ichorous-rose-2246455"],
        ["Hail of Verglas", "https://www.wowhead.com/diablo-4/item/hail-of-verglas-2081143"],
        ["Sunbird's Gorget", "https://www.wowhead.com/diablo-4/item/sunbirds-gorget-2081193"],
    ]]
]);

export const getNewSeasonUniqueLinkArray = function (season) {
    let result = [];
    const newUniques = newSeasonUniques.get(season);
    let first = true;
    newUniques.forEach(uniqueNameAndLink => {
        if(first) {
            first = false;
        } else {
            result.push(", ");
        }
        result.push(getLink(uniqueNameAndLink[0], uniqueNameAndLink[1]));
    });
    return result;
}


